import React, { forwardRef } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { SectionCard, ChartTooltip, C, axisTick } from "../shared";

const FinancialsSection = forwardRef(({ profit }, ref) => (
  <SectionCard ref={ref} id="financials" icon="financials" title="Profit History">
    <ResponsiveContainer width="100%" height={270}>
      <BarChart data={profit.history} margin={{ top: 8, right: 8, left: 0, bottom: 0 }} barCategoryGap="30%">
        <CartesianGrid strokeDasharray="3 3" stroke={C.grid} vertical={false} />
        <XAxis dataKey="year" tick={axisTick} tickLine={false} axisLine={{ stroke: C.border }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} width={54} tickFormatter={v => (v / 1000).toFixed(0) + "B"} />
        <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.03)" }} formatter={(v) => [(v / 1000).toFixed(2) + " B", undefined]} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="profit_before_tax" name="Profit Before Tax" fill={C.blue}  radius={[3, 3, 0, 0]} maxBarSize={16} isAnimationActive={false} />
        <Bar dataKey="profit_after_tax"  name="Profit After Tax"  fill={C.green} radius={[3, 3, 0, 0]} maxBarSize={16} isAnimationActive={false} />
      </BarChart>
    </ResponsiveContainer>
  </SectionCard>
));

export default FinancialsSection;
